"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pdf_viewer_component_1 = require("./pdf-viewer.component");
exports.PdfViewerComponent = pdf_viewer_component_1.PdfViewerComponent;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-pdf-viewer/dist/index.js
// module id = 1262
// module chunks = 13